export default __webpack_public_path__ + "static/media/control-1.3c90e8a5.svg";